import { ThemeConstants } from "./constants/color-theme-constants";
import { DOMHelper } from "./helpers/dom-helper";

export class Theme {
    init() {
        const element: HTMLElement | null = DOMHelper.querySelector(ThemeConstants.selector) as HTMLElement,
            themeName: string | undefined = element?.dataset.mcThemeName;

        if (themeName && themeName.length > 0) {
            this.setTheme(themeName)
        }
    }

    setTheme(name: string) {
        const html: HTMLElement | null = DOMHelper.querySelector("html") as HTMLElement;

        if (html) {
            html.className = html.className.replace(/theme_(\w*)/g, "");
            html.classList.add(name);
        }
    }
}
